import {Helmet} from '@dr.pogodin/react-helmet';
import {openDialog} from 'platform/components';
import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import {
  useLazyGetAiLeadEmailMessageQuery,
  useRetryAiLeadEmailMessageMutation,
} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {DmsDataGrid, EmailLeadPreviewDialog, handleApiError} from '@dms/shared';

import type {ActionCallback} from 'features/eag-grid';

export function AILeadEmailHistory() {
  const [retryEmailMessage] = useRetryAiLeadEmailMessageMutation();
  const [getAILeadMessage] = useLazyGetAiLeadEmailMessageQuery();

  const actionCallback: ActionCallback = ({actionKey, rowId, refreshData}) => {
    const id = isArray(rowId) ? rowId[0] : rowId;

    match(actionKey)
      .with('retry', () => {
        retryEmailMessage({emailMessageId: id})
          .unwrap()
          .then(() => refreshData())
          .catch(handleApiError);
      })
      .with('preview', () => {
        getAILeadMessage({id})
          .unwrap()
          .then((message) => {
            openDialog(<EmailLeadPreviewDialog message={message} />, {
              id: 'emailLeadPreviewDialog',
              size: 'large',
              title: i18n.t('entity.interest.aiLead.sentEmail'),
            });
          })
          .catch(handleApiError);
      });
  };

  return (
    <>
      <Helmet title={i18n.t('page.settings.labels.aiLeadEmailHistory')} />
      <SettingsTemplate
        header={{
          title: i18n.t('page.settings.labels.aiLeadEmailHistory'),
        }}
        data-testid={testIds.settings.aiLeadManagementHistory('page')}
      >
        <DmsDataGrid
          gridCode="ai-lead-received-message"
          actionCallback={actionCallback}
          data-testid={testIds.settings.aiLeadManagementHistory('data-grid')}
        />
      </SettingsTemplate>
    </>
  );
}
